import { url } from '@exodus/fetch/url';
class OrdersService {
    _baseUrl;
    _appName;
    _appPlatform;
    _appVersion;
    _fetchival;
    constructor({ baseUrl, appName, appVersion, appPlatform, fetchival, }) {
        this._baseUrl = new URL(baseUrl);
        this._appName = appName;
        this._appPlatform = appPlatform;
        this._appVersion = appVersion;
        this._fetchival = fetchival;
    }
    async insertDex(params, options) {
        return this._request(url `${this._baseUrl}/decentralized-orders`, options).post(params);
    }
    async updateDex(params) {
        return this._request(url `${this._baseUrl}/decentralized-orders/${params.id}`).patch({
            transactionId: params.transactionId,
            ...(params.providerOrderId ? { providerOrderId: params.providerOrderId } : {}),
        });
    }
    _request(url, { anonymousId } = {}) {
        return this._fetchival(url, {
            headers: {
                'App-Name': this._appName,
                'App-Version': this._appVersion,
                ...(this._appPlatform ? { 'App-Platform': this._appPlatform } : {}),
                ...(anonymousId ? { anonymousId } : {}),
            },
        });
    }
}
export default OrdersService;
